import { IntegerFilterType } from '../../../../../types';

export const enum UniversalFilterNumberModes {
  IS = 'is',
  IS_NOT = 'is_not',
  IS_EMPTY = 'is_empty',
  IS_NOT_EMPTY = 'is_not_empty',
  GREATER_THAN_EQUAL = 'greater_than_equal',
  LESS_THAN_EQUAL = 'less_than_equal'
}

export type UniversalFilterNumberValue = IntegerFilterType;

export type UniversalFilterNumberFilterState = {
  mode: UniversalFilterNumberModes;
  value?: number;
};

export type UniversalFilterNumberFilterOptions = {
  availableModes: UniversalFilterNumberModes[];
};

export type UniversalFilterNumberOnFilterStateChange = (
  state: UniversalFilterNumberFilterState
) => void;

export type UniversalFilterNumberOnChange = (
  value?: UniversalFilterNumberValue
) => void;
